import React from "react";
import TextInput from './TextInput'
import TimeInput from './TimeInput'
import TextNumberInput from './TextNumberInput'
import SelectInput from './SelectInput'
import FixButton from './Button'
import Cookies from 'universal-cookie';
import Utils from '../utils/utils';
import { EditorState } from 'draft-js';
import GetInsegnanti from '../services/getInsegnanti';
import GetMaterie from '../services/getMaterie';
import GetAule from '../services/getAule';
import getCorsi from '../services/getCorsi';
import DeleteLezione from '../services/deleteLezione';
import UpdateAula from '../services/updateAula';
import updateLezione from '../services/updateLezione';
import CheckBox from "../widgets/CheckBox";
import Switch from 'react-switch';
import './css/style.css';

// Styles
import '../pages/landingPage/style.css';
import addZoomMeeting from "../services/addZoomMeeting";
import moment from "moment";
import translateString from "../utils/Locales";

let t = translateString;

export default class EditMeetingWidget extends React.Component {

    constructor (props){
        super(props);

        this.selectRef = React.createRef();

        let date = this.props.meeting.data.split(' ')[0];
        let time = this.props.meeting.data.split(' ')[1];
        let hour = time.split(':')[0];
        let minutes = time.split(':')[1];

        let durata = this.props.meeting.durata;

        let eventTime = Utils.roundTime(hour) + ":" + Utils.roundTime(minutes);

        this.subjects = [];
        this.subjectsRepresentative = [];
        this.valueRepresentative = [];
        this.state = {
            visible: false,
            selected: 'event',
            time: eventTime,
            date: date,
            durata: durata,
            slots: durata,
            editorState: EditorState.createEmpty(),
            altri_insegnanti: [],
            altriCorsi: [], 
            startingOnline: this.props.meeting.online === "1",
            isOnline: this.props.meeting.online === "1", 
            join_link: this.props.meeting.join_link,
            host_link: this.props.meeting.host_link, 
            join_pwd: this.props.meeting.join_pwd,
        }
    }

    async componentDidMount(){
        let scheduleType = this.props.scheduleType;
        this.subjects = [];
        this.savedEnabled = false;
        this.brokersSelected = [];

        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        this.dbPath = cookies.get('db_path', { path: '/' });
        
        this.insegnanti = await GetInsegnanti(username, token);
        this.materie = await GetMaterie(username, token);
        this.aule = await GetAule(username, token);
        this.corsi = await getCorsi(username, token);

        this.altriInsegnanti = [];
        this.altriCorsi = [];

        this.props.meeting.altri_insegnanti.split(';').forEach(i => {
            if (i == '') return;
            var insegnante = this.insegnanti.find(temp => temp.id == i);
            if (insegnante == undefined) return;
            this.altriInsegnanti.push({
                value: insegnante.id, 
                label: insegnante.nome.replace(/\\/g, '') + ' ' + insegnante.cognome.replace(/\\/g, '')
            });
        });

        this.props.meeting.altri_corsi.split(';').forEach(i => {
            if (i == '') return;
            var corso = this.corsi.find(temp => temp.id == i);
            if (corso == undefined) return;
            this.altriCorsi.push({
                value: corso.id, 
                label: corso.name
            });
        });

        this.insegnanti.forEach(i => {
            if (i.id == this.props.meeting.id_insegnante){
                this.currentInsegnante = { value: i.id, label: i.nome.replace(/\\/g, '') + ' ' + i.cognome.replace(/\\/g, '')};
            }
        })

        this.selectMaterie = [];

        this.materie.forEach(i => {
            if (i.id_insegnante != this.props.meeting.id_insegnante) return;
            this.selectMaterie.push({ value: i.id, label: i.materia.replace(/\\/g, '')});             

            if (i.id == this.props.meeting.id_materia)
                this.materia = { value: i.id, label: i.materia.replace(/\\/g, '')}
        })

        this.selectInsegnanti = [];
        this.selectCorsi = [];
        this.selectAule = [];

        let currentAula = undefined;

        this.aule && this.aule.forEach(b => {
            this.selectAule.push({ value: b.id, label: b.nome.replace(/\\/g, '')});
            if (b.id == this.props.meeting.id_aula)
                currentAula = { value: b.id, label: b.nome.replace(/\\/g, '')};
        })

        this.insegnanti && this.insegnanti.forEach(b => {
            this.selectInsegnanti.push({ value: b.id, label: b.nome.replace(/\\/g, '') + ' ' + b.cognome.replace(/\\/g, '')});
        })

        this.corsi && this.corsi.forEach(b => {
            this.selectCorsi.push({ value: b.id, label: b.name.replace(/\\/g, '')});
        })

        this.setState({
            aula: currentAula,
            visible: this.props.visible,
            scheduleType: scheduleType,
            value: this.currentInsegnante,
            altriInsegnanti: this.altriInsegnanti,
            altriCorsi: this.altriCorsi,
            materia: this.materia,
            divisione_fatturato: this.props.meeting.divisione_fatturato
        });
    }

    onContentStateChange = contentState => {

        this.savedEnabled = true;
        this.setState({ contentState});
    }

    render (){

        if (this.props.meeting == undefined) return null;
        let st = Object.assign({minHeight: '600px', display: this.state.visible ? 'block' : 'none'})

        return ( 
        <div key={Math.random()} style={st} >
            <div style={container} onClick={() => { this.props.onDone(); this.setState({ visible: false }); }}>
                <div style={mainClass} onClick={(e) => e.stopPropagation()}>
                <div style={closeBtn} onClick={() => {
                this.setState({visible: false});
                this.props.onDone();
            }}>
                <img alt="" src={ require('../images/close_icon.png')} style={{ width: 30, height: 30, cursor: 'pointer' }} />
            </div>
            <div style={{ marginTop: '10px', display: this.state.selected == 'event' ? 'block' : 'none' }}>
                <div style={windowTitle}>{t('modifica_lez')}</div>

                <div style={{textAlign: 'left', marginTop: -5, marginLeft: 5, color: '#F58320', fontWeight: 'bold', fontSize: 18, cursor: 'pointer', fontFamily: 'Teko' }} onClick={() => {
                        const cookies = new Cookies();
                        cookies.set('currentLezione', this.props.meeting.id, { path: '/' });
                        cookies.set('currentMateria', this.strMateria, { path: '/' });
                        cookies.set('currentInsegnante', this.strInsegnante, { path: '/' });
                        cookies.set('scrollToDate', this.props.date, { path: '/' });

                        window.location.href =  '/' + this.dbPath + '/#/app/gestionePresenze';
                }}>{t('gestione_presenze')}</div><br/>

                <label style={{ marginTop: 10, marginLeft: 5 }}>
                    <span>{t('lez_online')} </span>
                    <Switch uncheckedIcon={false} checkedIcon={false} className="switch" width={40} height={20} onChange={(checked) => this.setState({ isOnline: checked })} checked={this.state.isOnline} />
                </label>

                <TextInput readOnly={true} name={t('data')} style={{ borderBottom: '1px solid darkgrey', borderTop: '0px', borderLeft: '0px', borderRight: '0px', backgroundColor: 'white', paddingLeft: 2, width: '290px' }} value={this.state.date} />
                <TimeInput readOnly={true} name={t('orario')} value={this.state.time} inputStyle={{ borderBottom: '1px solid darkgrey', borderTop: '0px', borderLeft: '0px', borderRight: '0px', backgroundColor: 'white', paddingLeft: 2, width: '290px' }} onChange={(val) => this.setState({time: val}) }/>

                <TextNumberInput name={t('durata')} inputStyle={{ borderBottom: '1px solid darkgrey', borderTop: '0px', borderLeft: '0px', borderRight: '0px', backgroundColor: 'white', paddingLeft: 2, width: '290px' }} value={this.state.slots} 
                    minValue="1" maxValue="600"
                    onChange={(val) => 
                        this.setState({slots : val})}/>

                <SelectInput key={Math.random()} 
                    ref={this.selectRef}
                    value={this.state.value} 
                    name={t('insegnante')} 
                    options={this.selectInsegnanti} 
                    onChange={(option) => {

                        if (this.state.value && option.value == this.state.value.value) return;
                        this.selectMaterie = [];
                        this.insegnanti && this.insegnanti.forEach(i => {
                            if (i.id != option.value) return;   
                            this.materie.forEach(m => {
                                if (m.id_insegnante != i.id) return;
                                this.selectMaterie.push({ value: m.id, label: m.materia});
                                }
                            )
                        })
                        this.setState({value: option, 
                            materia: undefined
                        })} 
                    }
                    />

                <SelectInput key={Math.random()} 
                    ref={this.selectRef}
                    value={this.state.materia} 
                    name={t('materia')} 
                    options={this.selectMaterie} 
                    onChange={(option) => 
                        this.setState({materia: option})} 
                    />

                <SelectInput key={Math.random()} 
                    ref={this.selectRef}
                    value={this.state.altriInsegnanti} 
                    name={t('altri_insegnanti')} 
                    options={this.selectInsegnanti} 
                    isMulti={true}
                    onChange={(option) => {

                        this.setState({
                            altriInsegnanti: option
                        });
                    }}
                    />


                <SelectInput key={Math.random()} 
                    ref={this.selectRef}
                    value={this.state.altriCorsi} 
                    name={t('altri_corsi')} 
                    options={this.selectCorsi} 
                    isMulti={true}
                    onChange={(option) => {

                        this.setState({
                            altriCorsi: option
                        });
                    }}
                    />

                <div style={{ marginLeft: 5 }}>{t('divisione_fatturato')}
                <CheckBox checked={this.state.divisione_fatturato == 1 ? true : false} 
                name={'Divisione fatturato lezione'} 
                onElementCheck={(val) => { this.setState(prevState => ({
                    divisione_fatturato: val == true ? 1 : 0                    
                }))}
                }
                />
                </div>

                { !this.state.isOnline && 
                    <SelectInput key={Math.random()} 
                        ref={this.selectRef}
                        value={this.state.aula} 
                        name={t('aula')} 
                        options={this.selectAule} 
                        onChange={(option) => 
                            this.setState({aula: option})} 
                    />
                }
                    <br/>
                    <FixButton title={t('salva')} callback={this.checkOnlineMeeting.bind(this)} />
                    <FixButton title={t('elimina')} callback={this.deletePressed.bind(this)} />
            </div>
                </div>
            </div>
        </div>
        )
    }

    async saveBreak(){

    }

    checkInvestor(investors, id){
        investors.map(v => {
            if (v.id == id) return true;
        });
        return false;
    }

    async deletePressed(){

       if (window.confirm("Eliminare la lezione?")) {
            this.deleteMeeting(this.props.meeting.id);
        } else {

        }
    }

    async deleteMeeting(id){
        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });

        await DeleteLezione(username, token, id);

        this.props.onDone();
    }

    async checkOnlineMeeting() {
        if (this.state.isOnline) {
            if (this.state.startingOnline) {
                await this.saveLezione();
            } else {
                if (this.state.host_link !== null && this.state.host_link !== '') {
                    await this.saveLezione();
                } else {
                    const cookies = new Cookies();
                    const username = cookies.get('username', { path: '/' });
                    const token = cookies.get('token', { path: '/' });
                    await addZoomMeeting(username, token, 'Lezione di ' + this.state.materia.label, moment(this.props.meeting.data.split(' ')[0] + ' ' + this.props.meeting.data.split(' ')[1], 'yyyy-MM-DD HH:mm').format('yyyy-MM-DDTHH:mm:ssZ'), this.state.slots * 60, 'Lezione di ' + this.state.materia.label + ' con: ' + this.state.value.label).then( async (res) => { this.setState({ host_link: res.start_url, join_link: res.join_url, join_pwd: res.password });  await this.saveLezione(); });
                }
            }
        } else {
            await this.saveLezione();
        }
    }

    async saveLezione() {

        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        const currentEventId = cookies.get('currentEventId', { path: '/' });

        if (!this.state.value) {
            alert ('Inserire un insegnante');
            return;
        }

        var id_insegnante = this.state.value.value;
        if (!this.state.materia) {
            alert ('Inserire la materia');
            return;
        }

        var id_materia = this.state.materia.value;

        var altriInsegnanti = '';
        this.state.altriInsegnanti && this.state.altriInsegnanti.forEach(i => {
            altriInsegnanti += i.value + ';';
        })

        var altriCorsi = '';
        this.state.altriCorsi && this.state.altriCorsi.forEach(i => {
            altriCorsi += i.value + ';';
        })
        
        let idLezione = this.props.meeting.id;
        let idAula = this.state.aula.value;
        let divisione_fatturato = this.state.divisione_fatturato;

        let date = this.props.meeting.data.split(' ')[0];
        let hour = this.state.time.split(':')[0];
        let minutes = this.state.time.split(':')[1];
        const durata = this.state.slots;

        var res = await updateLezione(username, token, idLezione, date, hour, minutes, durata, id_insegnante, altriInsegnanti, altriCorsi, this.props.meeting.id_corso, id_materia, idAula, divisione_fatturato, this.state.isOnline, this.state.join_link, this.state.host_link, this.state.join_pwd);
        if (res.result != 'ok'){
            alert (res.description);
            return;
        }

        let newLesioneId = res.element_id;
        var res = await UpdateAula(username, token, newLesioneId, idAula, this.props.meeting.data, durata);
        if (res.result != 'ok'){
            alert (res.description);
        } else 
            this.props.onDone();
    }

    handleChangeMultiple = (event) => {
        const { options } = event.target;
        const value = [];
        for (let i = 0, l = options.length; i < l; i += 1) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        this.setState({value: value})
      };

}

const windowTitle = {
    color: 'darkgrey', 
    fontSize: 30, 
    fontWeight: 'bold', 
    fontFamily: 'Teko', 
    textAlign:'left', 
    marginLeft: 5, 
}

const mainClass = {
    
    position: 'absolute',
    top: '90px',
    left: 'calc((100% - 365px)/2)', 
    height: '600px',
    background: 'white',
    padding: '2%', 
    width: '365px',
    minWidth: '360px',
    boxShadow: '0px 2px 10px darkgrey',
    borderRadius: '10px', 
    overflowX: 'hidden', 
    overflowY: 'scroll',
}

const container = {
    position: 'fixed', 
    display: 'block', 
    top: 0,
    left: 0, 
    bottom: 0, 
    right: 0,
    minWidth: '100%', 
    minHeight: '100%', 
    backgroundColor: '#3C3C3C4D',
    overflowX: 'hidden', 
    overflowY: 'scroll',
}

const closeBtn = {
    position: 'absolute',
    right: 10,
    top: 10,
    padding: 10,
    cursor: 'pointer', 
    zIndex: 999, 
}